<script>
	import Head from  "$lib/sections/Head.svelte";
	import Features from  "$lib/sections/Features.svelte";
	import Testimonials from  "$lib/sections/Testimonials.svelte";

	export let data;

	let lang;
	$: lang = data.lang;

	let area;
	$: area = data.area;

	const col = "home";
</script>

<Head {data} {lang} {area} {col} settingId={"Head"} />

<Features {data} {lang} {area} {col} settingId={"Features Hero"} />

<Features {data} {lang} {area} {col} settingId={"Features Specialize"} />

<Features {data} {lang} {area} {col} settingId={"Features"} />

<Testimonials {data} {lang} {area} {col} settingId={"Testimonials"} />

<Features {data} {lang} {area} {col} settingId={"Features Thomas"} />
